import {Suspense} from "react";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {ServiceTag} from "@/lib/types/checks.ts";
import {TagForm} from "@/pages/tags/edit/TagForm.tsx";

interface EditTagModalProps {
  show: boolean;
  hide: () => void;
  onSaved?: (tag: ServiceTag) => void;
  submitBtnText?: string;
}

const formId = "tag-form";

export const EditTagModal = ({show, hide, onSaved, submitBtnText}: EditTagModalProps) => {
  return (
    <Suspense>
      <UpErrorBoundary>
        <FormModal title="Create New Tag" onCancel={hide} show={show} formId={formId} submitBtnText={submitBtnText}>
          <TagForm
            formId={formId}
            onSave={(tag) => {
              onSaved?.(tag);
              hide();
            }}
            inputFieldClassname={"w-100"}
            showActionButtons={false}
            autoFocus={true}
          />
        </FormModal>
      </UpErrorBoundary>
    </Suspense>
  );
};
